import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';
import api from '../services/api';

const Grievance = () => {
  const [departments, setDepartments] = useState([]);
  const [formData, setFormData] = useState({
    complainant_name: '',
    complainant_email: '',
    complainant_phone: '',
    complainant_address: '',
    subject: '',
    description: '',
    department: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [complaintNo, setComplaintNo] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    try {
      const response = await api.get('/departments/');
      setDepartments(response.data);
    } catch (error) {
      console.error('Error loading departments:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const response = await api.post('/submit-grievance/', formData);
      setComplaintNo(response.data.complaint_no);
      setSubmitted(true);
      setFormData({
        complainant_name: '',
        complainant_email: '',
        complainant_phone: '',
        complainant_address: '',
        subject: '',
        description: '',
        department: ''
      });
    } catch (error) {
      setError('Failed to submit grievance. Please try again.');
      console.error('Error submitting grievance:', error);
    }
  };

  return (
    <Container className="py-5">
      <h1 className="page-title mb-4">Public Grievance</h1>
      
      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Submit Your Complaint</Card.Title>
          <Card.Text>
            Use this form to register your grievance or complaint. We will address your concern at the earliest.
          </Card.Text>
        </Card.Body>
      </Card>

      {submitted && (
        <Alert variant="success">
          <Alert.Heading>Grievance Submitted Successfully!</Alert.Heading>
          <p>Your complaint number is: <strong>{complaintNo}</strong></p>
          <p>Please save this number for tracking your grievance status.</p>
        </Alert>
      )}

      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Full Name *</Form.Label>
          <Form.Control
            type="text"
            name="complainant_name"
            value={formData.complainant_name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email *</Form.Label>
          <Form.Control
            type="email"
            name="complainant_email"
            value={formData.complainant_email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Phone *</Form.Label>
          <Form.Control
            type="tel"
            name="complainant_phone"
            value={formData.complainant_phone}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Address</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            name="complainant_address"
            value={formData.complainant_address}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Related Department *</Form.Label>
          <Form.Select
            name="department"
            value={formData.department}
            onChange={handleChange}
            required
          >
            <option value="">Select Department</option>
            {departments.map(dept => (
              <option key={dept.id} value={dept.id}>{dept.name}</option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Subject *</Form.Label>
          <Form.Control
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Grievance Description *</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            placeholder="Describe your grievance in detail..."
          />
        </Form.Group>

        <Button variant="primary" type="submit" size="lg">
          Submit Grievance
        </Button>
      </Form>
    </Container>
  );
};

export default Grievance;
